import React from "react";
import { Link, useLocation } from "react-router-dom";
import { IoMdLogOut } from "react-icons/io";

const SideMenu = ({ menuItems, setIsOpen }) => {
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    window.location = "/";
  };

  return (
    <div className="flex flex-col h-full">
      <div className="flex flex-col gap-6 flex-1 overflow-x-auto py-4">
        {menuItems.map(({ path, label, Icon }) => {
          const isActive = location.pathname === path;
          return (
            <Link
              key={path}
              to={path}
              onClick={() => {
                if (window.innerWidth < 768) {
                  setIsOpen(false);
                }
              }}
              className={`flex items-center gap-3 px-6 cursor-pointer ${
                isActive
                  ? "text-brand font-medium"
                  : "text-[#000] hover:text-brand"
              }`}
            >
              <Icon
                color={isActive ? "#2368CF" : "#000"}
                iconClass="w-5 h-5 flex-shrink-0"
              />
              <span className="text-sm">{label}</span>
            </Link>
          );
        })}
      </div>

      {/* Logout at bottom */}
      <div
        className="mt-auto flex items-center gap-2 px-6 py-4 border-t border-[#142b701a] cursor-pointer"
        onClick={handleLogout}
      >
        <IoMdLogOut className="w-6 h-6 flex-shrink-0" color="#2368CF" />
        <p className="text-sm font-medium text-[#2368CF]">Logout</p>
      </div>
    </div>
  );
};

export default SideMenu;
